// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {useCallback, useState} from 'react';
import {useMapLocation} from '~/common/hooks/useMapLocation';
import {CustomInputWithIcon} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/CustomInputWithIcon/CustomInputWithIcon';
import {AddressOverlay} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/WhereFields/AddressOverlay';

import './WhereFields.sass';

export const WhereFields = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const openOverlay = useCallback(() => {
    setShowOverlay(true);
  }, [setShowOverlay]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const closeOverlay = useCallback(() => {
    setShowOverlay(false);
  }, [setShowOverlay]);

  const {placeId, showMap, formatAddress} = useMapLocation();

  return (
    <>
      {showOverlay && <AddressOverlay isOpen={showOverlay} closeOverlay={closeOverlay} />}
      <CustomInputWithIcon
        id="location"
        name="location"
        dataQaId="edit-eventlocation"
        type="text"
        value={formatAddress()}
        onClick={openOverlay}
        placeholder="Event location and address"
        className="whereFields__location-edit"
        showEditIcon={false}
        fullWidth
      />
      {placeId && showMap && (
        <iframe
          title="Google Map"
          width="100%"
          height="240"
          loading="lazy"
          allowFullScreen
          className="view-invitation__map"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${window.mapEmbedApiKey}
    &q=place_id:${placeId}`}
        />
      )}
    </>
  );
};
